const TERMINAL_QR_HARDCODED_YPF = {
  idTerminalTarjeta: 23,
  descripcion: "MobilePos",
};

const getIdTalonarioQR = async () => {
  return {
    data: TERMINAL_QR_HARDCODED_YPF,
  };
};

const talonarioQR = {
  getIdTalonarioQR,
};

export default talonarioQR;
